// src/components/ContaCorrenteModal.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from './Button';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 500px;
`;

const FormGroup = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: bold;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
`;

const ContaCorrenteModal = ({ isOpen, onClose, onSave, initialData }) => {
    const [banco, setBanco] = useState('');
    const [agencia, setAgencia] = useState('');
    const [conta, setConta] = useState('');
    const [descricao, setDescricao] = useState('');

    useEffect(() => {
        if (initialData) {
            setBanco(initialData.banco || '');
            setAgencia(initialData.agencia || '');
            setConta(initialData.conta || '');
            setDescricao(initialData.descricao || '');
        } else {
            setBanco('');
            setAgencia('');
            setConta('');
            setDescricao('');
        }
    }, [initialData]);

    const handleSubmit = () => {
        onSave({
            id: initialData?.cod,
            banco,
            agencia,
            conta,
            descricao
        });
    };

    return (
        <ModalOverlay isOpen={isOpen}>
            <ModalContent>
                <h3>{initialData ? 'Editar Conta Corrente' : 'Nova Conta Corrente'}</h3>
                <FormGroup>
                    <Label>Banco</Label>
                    <Input value={banco} onChange={e => setBanco(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>Agência</Label>
                    <Input value={agencia} onChange={e => setAgencia(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>Conta</Label>
                    <Input value={conta} onChange={e => setConta(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>Descrição</Label>
                    <Input value={descricao} onChange={e => setDescricao(e.target.value)} />
                </FormGroup>
                <ButtonRow>
                    <Button variant="secondary" onClick={onClose}>Cancelar</Button>
                    <Button variant="primary" onClick={handleSubmit}>Salvar</Button>
                </ButtonRow>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ContaCorrenteModal;
